const RELOAD_KEY = "qt-hq-deploy-reload";

export function isStaleDeployError(error) {
  if (!error) return false;
  const name = error.name || "";
  const message = error.message || String(error);
  return (
    name === "ChunkLoadError" ||
    /Loading chunk [\d]+ failed/i.test(message) ||
    /Loading CSS chunk [\d]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message) ||
    /error loading dynamically imported module/i.test(message)
  );
}

/**
 * One automatic reload per tab session after a deploy leaves stale assets.
 * Returns true if a reload was triggered.
 */
export function reloadForNewDeploy() {
  try {
    if (sessionStorage.getItem(RELOAD_KEY) === "1") {
      return false;
    }
    sessionStorage.setItem(RELOAD_KEY, "1");
  } catch (_) {
    // sessionStorage may be unavailable; still attempt a single reload.
  }
  window.location.reload();
  return true;
}

export function clearDeployReloadFlag() {
  try {
    sessionStorage.removeItem(RELOAD_KEY);
  } catch (_) {
    // ignore
  }
}
